import { createActionsHook } from 'src/lib/sweetState';

import { CommonStore } from './CommonStore';

export const useCommonActions = createActionsHook(CommonStore);
